import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { User } from "src/app/models/user-model";
import { AuthService } from "src/app/services/auth/auth.service";
import { ContactService } from "src/app/services/contact/contact.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";

import intlTelInput from "intl-tel-input";

import Swal from "sweetalert2";

import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";

@Component({
  selector: "app-contact",
  templateUrl: "./contact.component.html",
  styleUrls: ["./contact.component.scss"],
})
export class ContactComponent implements OnInit, AfterViewInit {
  currentUser: any;
  FormContact!: FormGroup;
  submitFormContact = false;
  phoneInputElement!: any;

  public Editor = ClassicEditor;

  constructor(
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private formBuilder: FormBuilder,
    private contactService: ContactService
  ) {
    this.FormContact = this.formBuilder.group({
      full_name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      phone: ["", Validators.required],
      country_phone: [""],
      country_code_phone: [""],
      subject: ["", Validators.required],
      message: ["", Validators.required],
      departement: ["autres", Validators.required],
    });
  }

  ngOnInit(): void {
    this.authService.currentUser.subscribe((user) => {
      if (user) {
        this.currentUser = User.toJson(
          user,
          this.authService.currentUserValue.token,
          this.authService.currentUserValue.is_connect_with,
          this.authService.currentUserValue.switch_account
        );
        this.initData();
      }
    });
  }

  initPhone(countryCode: string) {
    const inputElement = document.getElementById("phone");
    if (inputElement) {
      this.phoneInputElement = intlTelInput(inputElement as HTMLInputElement, {
        initialCountry: countryCode,
        separateDialCode: true,
      });
    }
  }

  ngAfterViewInit(): void {
    this.initPhone(
      this.currentUser?.profile?.phone
        ? this.currentUser?.profile?.country_phone
        : "FR"
    );
    Webflow.setIFrameHeight();
  }

  initData() {
    if (!this.currentUser.isEmpty) {
      this.FormContact.patchValue(this.currentUser.profile);
      this.FormContact.controls.departement.setValue("autres");
      /*
      this.FormContact.patchValue({
        phone: this.currentUser.profile.phone,
        country_phone: this.currentUser.profile.country_phone,
        country_code_phone: this.currentUser.profile.country_code_phone
      });
      */
    }
  }

  get contact() {
    return this.FormContact.controls;
  }

  onSubmit() {
    this.submitFormContact = true;
    if (this.FormContact.invalid) {
      Webflow.setIFrameHeight();
      Swal.fire({
        icon: "error",
        title: "Error",
        html:
          "<p>Veuillez vérifier vos informations</p>" +
          (this.FormContact.get("email")?.invalid &&
          this.FormContact.get("email")?.touched
            ? "<p>Le format de l'adresse email n'est pas valide</p>"
            : ""),
        confirmButtonText: "OK",
        position: "top",
      });
      return;
    }

    if (this.FormContact.value.phone.replace(/\s+/g, "").length != 9) {
      Swal.fire({
        title: "Attention",
        text: "Veuillez vérifier votre numéro de téléphone",
        icon: "info",
        position: "top",
      });
      return;
    }

    this.spinner.show();

    const countryData = this.phoneInputElement.getSelectedCountryData();
    this.FormContact.patchValue({
      phone: this.FormContact.value.phone.replace(/\s+/g, ""),
      country_phone: countryData.iso2,
      country_code_phone: "+" + countryData.dialCode,
    });

    this.contactService
      .create(this.FormContact.value)
      .subscribe(
        (res) => {
          Webflow.setIFrameHeight();
          Swal.fire({
            title: "Envoyé",
            text: "Votre message a bien été envoyé",
            icon: "success",
            position: "top",
          });
          //this.FormContact.reset();
          this.FormContact = this.formBuilder.group({
            full_name: ["", Validators.required],
            email: ["", [Validators.required, Validators.email]],
            phone: ["", Validators.required],
            country_phone: [""],
            country_code_phone: [""],
            subject: ["", Validators.required],
            message: ["", Validators.required],
            departement: ["autres", Validators.required],
          });
          this.initData();

          this.initPhone(
            this.currentUser?.profile?.phone
              ? this.currentUser?.profile?.country_phone
              : "FR"
          );

          this.submitFormContact = false;
        },
        (error) => {
          if (GenerateErrors.check_if_is_custom_error(error)) {
            Swal.fire({
              title: "Erreur",
              text: GenerateErrors.get_message_error(error),
              icon: "error",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Une érreur est survenue",
              icon: "error",
              position: "top",
            });
          }
        }
      )
      .add(() => {
        this.spinner.hide();
      });
  }
}
